
import api from "./client";

export default {
    isOnline(){
       // return api.post('/isOnline', {});
    },

    login(data) {
        return api.post('/auth/login', data);
    },
    register(data) {
        return api.post('/auth/register', data);
    },
    verify(data) {
        return api.post('/auth/verify', data);
    },
    forgotPassword(data) {
        return api.post('/auth/forgotPassword', data);
    },
    setNewPassword(data) {
        return api.post('/auth/setNewPassword', data);
    },
    resetPassword(data) {
        return api.post('/auth/resetPassword', data);
    },
    logout() {
        return api.post('/auth/logout', {}).then((resp) => {
            window.location = resp.data;
        });
    },
    connect(data) {
        return api.post('/auth/connect', data)
    },

    switch(data) {
        return api.post('/auth/switch', data)
    }
}

